const styles = {
  grid: {
    display: 'flex',
    flexDirection: 'column',
    margin: '.500rem 2rem',
  },
  label: {
    color: '#999',
    fontSize: '.750rem',
    fontWeight: 'bold',
    letterSpacing: '.125rem',
    marginBottom: '.625rem',
    whiteSpace: 'nowrap',
  },
  secondaryData: {
    color: '#683caf !important',
    fontSize: '.75rem !important',
    lineHeight: 1,
    fontWeight: 'bold',

    '& *': {
      fontWeight: 'bold !important',
    },
  },
  progressBar: {
    margin: '.3125rem 0 !important',
  },
  completed: {
    backgroundColor: '#a9b8c2 !important',
  },
  success: {
    backgroundColor: '#39e27a !important',
  },
  error: {
    backgroundColor: '#f55947 !important',
  },
  warning: {
    backgroundColor: '#f8a757 !important',
  },
};

export default styles;
